import React from 'react';
import { Link } from "gatsby"
import theme from "../design-system/theme";

export default class TymeLink extends React.PureComponent {

    render() {
        let {children, to, ...other} = this.props;

        if (to.includes("http://") || to.includes("https://")) {
            return (
                <a href={to} {...other} target="_blank" rel="noreferrer">
                    {children}
                </a>
            );
        }

        // get the anchor parts from the link
        let anchorParts = "";
        const parts = to.split("#");
        if (parts.length > 1) {
            anchorParts = "#" + parts[1];
        }

        // get the regular link parts
        let linkComponents = parts[0].split("/");
        linkComponents.shift();

        // get the current location language

        let locationComponents = theme.windowPathName.split("/");
        locationComponents.shift();
        const language = locationComponents[0];

        // if there is a language already in the link, delete it, otherwise we would end up with: /de/de
        if (linkComponents[0] === language) {
            linkComponents.shift();
        }

        let newTarget = "/" + language + "/" + linkComponents.join("/");

        if (newTarget.slice(-1) !== "/") {
            newTarget += "/";
        }

        // add search params to link
        newTarget += theme.windowSearch;
        newTarget += anchorParts;

        return (
            <Link to={newTarget} {...other}>
                {children}
            </Link>
        );
    }
}